import React from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import WithValidation from '../../lib/WithValidation';
import Input from '../../components/Input';
import Button from '../../components/Button';
import require from '../../lib/WithValidation/rules/required';
import password from '../../lib/WithValidation/rules/password';
import match from '../../lib/WithValidation/rules/match';
import PropTypes from 'prop-types';
import translate from '../../lib/utils/translate';

var ChangePassword = function ChangePassword(_ref) {
  var errors = _ref.errors,
      intl = _ref.intl,
      onSubmit = _ref.onSubmit,
      _onBlur = _ref.onBlur;

  return React.createElement(
    'form',
    { className: 'form', onSubmit: onSubmit },
    React.createElement(Input, {
      label: translate({
        id: 'title.old_password',
        defaultMessage: 'Old password'
      }, intl),
      type: 'password',
      name: 'CurrentPassword',
      onBlur: function onBlur(e) {
        return _onBlur('CurrentPassword', e.target.value);
      },
      status: errors.CurrentPassword && 'failure' || 'idle',
      statusText: errors.CurrentPassword && translate({ id: errors.CurrentPassword }, intl),
      autoComplete: 'current-password'
    }),
    React.createElement(Input, {
      label: translate({
        id: 'title.new_password',
        defaultMessage: 'New password'
      }, intl),
      type: 'password',
      name: 'NewPassword',
      onBlur: function onBlur(e) {
        return _onBlur('NewPassword', e.target.value);
      },
      status: errors.NewPassword && 'failure' || 'idle',
      statusText: errors.NewPassword && translate({ id: errors.NewPassword }, intl),
      autoComplete: 'new-password'
    }),
    React.createElement(Input, {
      label: translate({
        id: 'title.confirm_password',
        defaultMessage: 'Confirm password'
      }, intl),
      type: 'password',
      name: 'confirm_password',
      onBlur: function onBlur(e) {
        return _onBlur('confirm_password', e.target.value);
      },
      status: errors.confirm_password && 'failure' || 'idle',
      statusText: errors.confirm_password && translate({ id: errors.confirm_password }, intl),
      autoComplete: 'new-password'
    }),
    React.createElement(
      Button,
      { className: 'button primary wide', type: 'submit' },
      translate({ id: 'action.button.submit_new_password' }, intl)
    )
  );
};

ChangePassword.propTypes = {
  /** The form input fields and content */
  children: PropTypes.any,
  /** The above title for each field */
  label: PropTypes.string,
  /** The name of each field */
  name: PropTypes.string,
  /** Array of validation errors where the error display depends on which invalid rule it breaks */
  error: PropTypes.array,
  /** The submission function firing when submitting the form */
  onSubmit: PropTypes.func,
  /** When user moves focus from input field */
  onBlur: PropTypes.func
};

ChangePassword.defaultProps = {
  children: '',
  label: '',
  name: '',
  error: [],
  onSubmit: Function,
  onBlur: Function
};
var rules = {
  NewPassword: [[require, 'error.empty.new_password'], [password, 'error.condition.password']],
  confirm_password: [[match('NewPassword'), 'error.match.new_password']],
  CurrentPassword: [[require, 'error.empty.old_password']]
};

export default compose(WithValidation(rules), injectIntl)(ChangePassword);